import React from "react";
import Sidebar from "../Sidebar";
import styles from "./TwoColumnLayout.module.css";
import { mcn } from "../../../utils/mergeClassnames";

interface Props {
  children: React.ReactElement;
  sidebar?: React.ReactElement;
  transparent?: boolean;
  isResponsiveFixes?: boolean;
  hideContent?: boolean;
  sidebarContentLocation?: "top" | "bottom";
}

function TwoColumnLayout(props: Props) {
  const { children, sidebar, transparent, isResponsiveFixes, hideContent = true, sidebarContentLocation } = props;

  return (
    <section className={mcn(styles.root, isResponsiveFixes && styles.rootRes)}>
      {isResponsiveFixes && sidebarContentLocation === "top" ? (
        <div className={mcn(styles.sidebar, styles.sidebarResponsiveTop)}>
          <Sidebar transparent={transparent}>{sidebar}</Sidebar>
        </div>
      ) : null}
      <div className={mcn(styles.content, isResponsiveFixes && styles.contentRes)}>{children}</div>
      {!isResponsiveFixes && hideContent ? (
        <div className={styles.sidebar}>
          <Sidebar transparent={transparent}>{sidebar}</Sidebar>
        </div>
      ) : null}
      {isResponsiveFixes && sidebarContentLocation === "bottom" ? (
        <div className={mcn(styles.sidebar, styles.sidebarResponsiveBottom)}>
          <Sidebar transparent={transparent}>{sidebar}</Sidebar>
        </div>
      ) : null}
    </section>
  );
}

export default TwoColumnLayout;
